import { takeEvery } from 'redux-saga/effects';
import { Types } from 'store/ducks/signup';
import { postSignupUser } from './signup';

const signupSagas = [
	takeEvery(Types.POST_SIGNUP, postSignupUser)
]

export default signupSagas;